import { useSelector } from 'react-redux';

import { isAllowed } from '~utils/policies';

const UserPermissions = ({ policy, actions, children }) => {
  const { userActions } = useSelector((state) => state.adminUser);
  const shouldShowComponent = isAllowed(actions, userActions, policy);
  return shouldShowComponent && children;
};

export default UserPermissions;
